import React from 'react';
import { observer } from 'mobx-react';

import Section from '../uic/Section';
import { List, Row, Label, Value } from '../uic/list';

import TimeModel from '../models/TimeModel';

class TimeSection extends React.Component {
    state = {
        curTime: new Date().toLocaleTimeString()
    };

    updateTime = async () => {
        this.setState({
            curTime: new Date().toLocaleTimeString()
        });
    };

    componentWillMount() {
        const { session } = this.props.session;
        this.model = new TimeModel(session);
        this.model.load();
    }

    componentDidMount() {
        this.interval = setInterval(this.updateTime, 1000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        const model = this.model;

        return (
            <Section title="Time">
                <List>
                    <Row>
                        <Label>Time</Label>
                        <Value>{this.state.curTime} (UTC)</Value>
                    </Row>
                    <Row>
                        <Label>NTP Server</Label>
                        <Value style={{ fontSize: 12 }}>
                            {model.ntpserver}
                        </Value>
                    </Row>
                    <Row>
                        <Label>Uptime</Label>
                        <Value>{model.uptime}</Value>
                    </Row>
                </List>
            </Section>
        );
    }
}

export default observer(TimeSection);



// WEBPACK FOOTER //
// ./src/sections/Time.js